import { render } from "./return-form-component.vue?vue&type=template&id=271552e2&scoped=true"
import script from "./return-form-component.vue?vue&type=script&lang=js"
export * from "./return-form-component.vue?vue&type=script&lang=js"

import "./return-form-component.vue?vue&type=style&index=0&id=271552e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271552e2"]])

export default __exports__